import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getUsername } from '../utils/auth';

const RequireAuth = ({ children }) => {
  const location = useLocation();
  const [checked, setChecked] = useState(false);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      const username = await getUsername();
      if (!active) return;
      if (username) {
        setAllowed(true);
        setChecked(true);
      } else {
        const rd = window.location.href;
        window.location.href = `https://auth.deepprinter.cn/?rd=${encodeURIComponent(rd)}`;
      }
    })();
    return () => {
      active = false;
    };
  }, [location.key]);

  if (!checked) return null;
  return allowed ? children : null;
};

export default RequireAuth;

